export default {
  btnLogin: 'BTN_LOGIN',
  btnRecord: 'BTN_RECORD',
  btnCancel: 'BTN_CANCEL',
  btnUpdate: 'BTN_UPDATE',
  btnToday: 'BTN_TODAY',
  btnSeeMore: 'BTN_SEEMORE',
  btnReload: 'BTN_RELOAD',
  btnOK: 'BTN_OK',
  btnDeleteConfirm: 'BTN_DELETE_CONFIRM',
  btnSaveWithoutValidate: 'BTN_SAVE_WITHOUT_VALIDATE',
  btnSaveWithInValidate: 'BTN_SAVE_WITHIN_VALIDATE',
  btnCreateGroup: 'BTN_CREATE_GROUP',
  btnClose: 'BTN_CLOSE',
  btnSaveAndCreateAppartments: 'BTN_SAVE_CREATE_APPARTMENT',
  btnMAJ: 'BTN_MAJ',
  btnDisable: 'BTN_DISABLE',
  btnEnable: 'BTN_ENABLE',
}



// WEBPACK FOOTER //
// ./src/locales/button/index.ts